"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLapsedAndFlpCurrentPathway = exports.isFlpRegularType = exports.isFlpCandidateType = exports.isFlpAffiliateType = exports.isCimaCgmaAffiliateType = exports.isCimaRetiredType = exports.isCimaCandidateType = exports.isAicpaAffiliateType = exports.isCimaAffiliateType = exports.isCimaApprenticeCandidateProductType = exports.isChinesePQCandidateProductType = exports.isCimaPQCandidateProductType = exports.isCimaRegularType = exports.isAicpaMemBody = exports.isCimaMemBody = exports.isFlpPathway = exports.isApprenticePathway = exports.isChinesePathway = exports.isCimaPqPathway = exports.similarGroupValidOrgs = exports.allInvalidOrgs = exports.cpeaInvalidOrgs = exports.pcpsInvalidOrgs = exports.generateMembershipAccessURL = exports.getFirmMembershipTypeForMemberhipSF = exports.transformFirmMembershipTypeToSlug = exports.isCimaMipProductType = exports.isOrgGovernmentType = exports.isGAQCorEBPAQCExceedCpa = exports.isEBPAQCType = exports.isGAQCType = exports.isPCPSType = exports.isCPEAType = exports.isCAQType = exports.GAQC_AND_EBPAQC_NORMAL_USER_MIN_CPAS = exports.GAQC_AND_EBPAQC_IMPERSONATED_MIN_CPAS = void 0;
const mxp_schemas_1 = require("mxp-schemas");
const crypto_1 = require("crypto");
exports.GAQC_AND_EBPAQC_IMPERSONATED_MIN_CPAS = 15000;
exports.GAQC_AND_EBPAQC_NORMAL_USER_MIN_CPAS = 2499;
const isCAQType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.CAQ.toLowerCase();
exports.isCAQType = isCAQType;
const isCPEAType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.CPEA.toLowerCase();
exports.isCPEAType = isCPEAType;
const isPCPSType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.PCPS.toLowerCase();
exports.isPCPSType = isPCPSType;
const isGAQCType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.GAQC.toLowerCase();
exports.isGAQCType = isGAQCType;
const isEBPAQCType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.EBPAQC.toLowerCase();
exports.isEBPAQCType = isEBPAQCType;
const isGAQCorEBPAQCExceedCpa = (membershipType, numberOfCpa, isImpersonated) => ((0, exports.isGAQCType)(membershipType.toLowerCase()) || (0, exports.isEBPAQCType)(membershipType.toLowerCase())) &&
    ((isImpersonated && Number(numberOfCpa) > exports.GAQC_AND_EBPAQC_IMPERSONATED_MIN_CPAS) ||
        (!isImpersonated && Number(numberOfCpa) > exports.GAQC_AND_EBPAQC_NORMAL_USER_MIN_CPAS));
exports.isGAQCorEBPAQCExceedCpa = isGAQCorEBPAQCExceedCpa;
const isOrgGovernmentType = (orgType) => Boolean(orgType === mxp_schemas_1.MembershipTypes.OrganizationType.GOVERNMENT);
exports.isOrgGovernmentType = isOrgGovernmentType;
const isCimaMipProductType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CimaMembershipProductSlug.MEMBERSHIP_IN_PRACTICE;
exports.isCimaMipProductType = isCimaMipProductType;
const transformFirmMembershipTypeToSlug = (firmMembershipType) => firmMembershipType === mxp_schemas_1.Salesforce.FirmMembershipTypes.CAQ_REGULAR ||
    firmMembershipType === mxp_schemas_1.Salesforce.FirmMembershipTypes.CAQ_ASSOCIATE
    ? mxp_schemas_1.MembershipTypes.CenterMembershipType.CAQ
    : firmMembershipType;
exports.transformFirmMembershipTypeToSlug = transformFirmMembershipTypeToSlug;
const getFirmMembershipTypeForMemberhipSF = (membershipType, isPCAOB = false) => {
    switch (membershipType) {
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.CPEA:
            return mxp_schemas_1.Salesforce.FirmMembershipTypes.CPEA;
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.PCPS:
            return mxp_schemas_1.Salesforce.FirmMembershipTypes.PCPS;
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.GAQC:
            return mxp_schemas_1.Salesforce.FirmMembershipTypes.GAQC;
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.EBPAQC:
            return mxp_schemas_1.Salesforce.FirmMembershipTypes.EBPAQC;
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.CAQ:
            return isPCAOB ? mxp_schemas_1.Salesforce.FirmMembershipTypes.CAQ_REGULAR : mxp_schemas_1.Salesforce.FirmMembershipTypes.CAQ_ASSOCIATE;
        default:
            return '';
    }
};
exports.getFirmMembershipTypeForMemberhipSF = getFirmMembershipTypeForMemberhipSF;
const generateMembershipAccessURL = (appUrl, orderLineItemId) => {
    const token = (0, crypto_1.createHash)('md5').update(`${Date.now()}:${orderLineItemId}`).digest('hex').substring(0, 10);
    return `${appUrl}/center-membership/provisioning/${token}`;
};
exports.generateMembershipAccessURL = generateMembershipAccessURL;
const pcpsInvalidOrgs = (businessType) => [mxp_schemas_1.MembershipTypes.OrganizationType.EDUCATION, mxp_schemas_1.MembershipTypes.OrganizationType.BUSINESS].includes(businessType);
exports.pcpsInvalidOrgs = pcpsInvalidOrgs;
const cpeaInvalidOrgs = (businessType) => [mxp_schemas_1.MembershipTypes.OrganizationType.FLP_UNIVERSITY, mxp_schemas_1.MembershipTypes.OrganizationType.GOVERNMENT].includes(businessType);
exports.cpeaInvalidOrgs = cpeaInvalidOrgs;
const allInvalidOrgs = (businessType) => [mxp_schemas_1.MembershipTypes.OrganizationType.OTHER].includes(businessType);
exports.allInvalidOrgs = allInvalidOrgs;
const similarGroupValidOrgs = (organizationType) => [
    mxp_schemas_1.MembershipTypes.CenterMembershipType.GAQC,
    mxp_schemas_1.MembershipTypes.CenterMembershipType.CAQ,
    mxp_schemas_1.MembershipTypes.CenterMembershipType.EBPAQC,
].includes(organizationType);
exports.similarGroupValidOrgs = similarGroupValidOrgs;
const isCimaPqPathway = (pathway) => pathway === mxp_schemas_1.MembershipTypes.Pathway.PQ;
exports.isCimaPqPathway = isCimaPqPathway;
const isChinesePathway = (pathway) => pathway === mxp_schemas_1.MembershipTypes.Pathway.CHINESE_PQ;
exports.isChinesePathway = isChinesePathway;
const isApprenticePathway = (pathway) => pathway === mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L4 || pathway === mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L7;
exports.isApprenticePathway = isApprenticePathway;
const isFlpPathway = (pathway) => pathway === mxp_schemas_1.MembershipTypes.Pathway.FLP;
exports.isFlpPathway = isFlpPathway;
const isCimaMemBody = (body) => body === mxp_schemas_1.MembershipTypes.MembershipBody.CIMA;
exports.isCimaMemBody = isCimaMemBody;
const isAicpaMemBody = (body) => body === mxp_schemas_1.MembershipTypes.MembershipBody.AICPA;
exports.isAicpaMemBody = isAicpaMemBody;
const isCimaRegularType = (body, membershipType) => {
    return (0, exports.isCimaMemBody)(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.REGULAR;
};
exports.isCimaRegularType = isCimaRegularType;
const isCimaPQCandidateProductType = (pathway, membershipType) => {
    return (0, exports.isCimaPqPathway)(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isCimaPQCandidateProductType = isCimaPQCandidateProductType;
const isChinesePQCandidateProductType = (pathway, membershipType) => {
    return (0, exports.isChinesePathway)(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isChinesePQCandidateProductType = isChinesePQCandidateProductType;
const isCimaApprenticeCandidateProductType = (pathway, membershipType) => {
    return (0, exports.isApprenticePathway)(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isCimaApprenticeCandidateProductType = isCimaApprenticeCandidateProductType;
const isCimaAffiliateType = (body, membershipType) => {
    return (0, exports.isCimaMemBody)(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.AFFILIATE;
};
exports.isCimaAffiliateType = isCimaAffiliateType;
const isAicpaAffiliateType = (body, membershipType) => {
    return (0, exports.isAicpaMemBody)(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.AFFILIATE;
};
exports.isAicpaAffiliateType = isAicpaAffiliateType;
const isCimaCandidateType = (body, membershipType) => {
    return (0, exports.isCimaMemBody)(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isCimaCandidateType = isCimaCandidateType;
const isCimaRetiredType = (body, membershipType) => {
    return (0, exports.isCimaMemBody)(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.RETIRED;
};
exports.isCimaRetiredType = isCimaRetiredType;
const isCimaCgmaAffiliateType = (body, membershipType) => {
    return (0, exports.isCimaMemBody)(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CGMA_AFFILIATE;
};
exports.isCimaCgmaAffiliateType = isCimaCgmaAffiliateType;
const isFlpAffiliateType = (pathway, membershipType) => {
    return (0, exports.isFlpPathway)(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.AFFILIATE;
};
exports.isFlpAffiliateType = isFlpAffiliateType;
const isFlpCandidateType = (pathway, membershipType) => {
    return (0, exports.isFlpPathway)(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isFlpCandidateType = isFlpCandidateType;
const isFlpRegularType = (pathway, membershipType) => {
    return (0, exports.isFlpPathway)(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.REGULAR;
};
exports.isFlpRegularType = isFlpRegularType;
const isLapsedAndFlpCurrentPathway = (isLapsed, pathway) => (0, exports.isFlpPathway)(pathway) && isLapsed;
exports.isLapsedAndFlpCurrentPathway = isLapsedAndFlpCurrentPathway;
//# sourceMappingURL=index.js.map